<form #alertForm="ngForm" [class.submitted]="alertForm.submitted"
      (ngSubmit)="processRecord(alertForm)" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">
      <span>{{(isEditMode ? "GENERICS.EDIT_VALUE" : "GENERICS.CREATE_NEW") | translate: { value: "ALERTS.ALERT" | translate } }}</span>
    </h4>
    <button type="button" class="btn btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Manual Alert Form -->
    <div class="row align-items-center" *ngIf="!isCompanyMemberAlertEdit">
      <!-- Company Name (shown only when companyId is not pre-set) -->
      <div class="col-12" *ngIf="!companyId">
        <div class="form-group">
          <label for="companyId">{{"MY_COMPANIES.COMPANY_NAME" | translate}}</label>
          <span class="error" *ngIf="alertForm.submitted">
            <span *ngIf="companyIdField?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
          </span>
          <ng-select
            rmsNgSelectEditFocused
            [items]="companyList"
            #companyIdField="ngModel"
            bindLabel="name"
            bindValue="id"
            [typeahead]="companyTypeahead"
            name="companyId"
            id="companyId"
            required
            (change)="handleCompanyChange($event)"
            [(ngModel)]="formAlert.companyId">
          </ng-select>
        </div>
      </div>

      <!-- Date, Time, AM/PM, and Repeat Row -->
      <div class="col-12">
        <div class="row align-items-baseline">
          <div class="col-auto">
            <div class="form-group">
              <label for="date">{{"GENERICS.DATE" | translate}}</label>
              <span class="error" *ngIf="alertForm.submitted">
                <span *ngIf="dateRef?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
              </span>
              <rms-date-picker id="date"
                               name="date"
                               #dateRef="ngModel"
                               [(ngModel)]="formAlert.date"
                               [isRange]="false"
                               required>
              </rms-date-picker>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <label for="alertHour">{{"GENERICS.TIME" | translate}}</label>
              <span class="error" *ngIf="alertForm.submitted">
                <span *ngIf="alertHourInput?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
                <span *ngIf="dateTimeInPast">{{"ERRORS.TIME_IN_PAST" | translate}}</span>
              </span>
              <input name="alertHour" id="alertHour" #alertHourInput="ngModel"
                     class="form-control time-input" type="text"
                     [pattern]="'([0][1-9])|1[0-2]:([0-5][0-9])'" placeholder="8:00"
                     (keyup.enter)="formatHour()" (blur)="formatHour()"
                     [(ngModel)]="alertHour" required>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-group mb-0">
              <label class="d-block">&nbsp;</label>
              <div class="ampm-toggle-group">
                <button type="button" class="btn ampm-toggle" [class.active]="ampm === 'am'"
                        (click)="ampm = 'am'; formatHour()">AM</button>
                <button type="button" class="btn ampm-toggle" [class.active]="ampm === 'pm'"
                        (click)="ampm = 'pm'; formatHour()">PM</button>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-group mb-0">
              <label class="d-block">&nbsp;</label>
              <div class="checkbox-inline d-flex align-items-center">
                <input type="checkbox" class="repeat-alert-checkbox" id="repeatAlert"
                       name="repeatAlert" [(ngModel)]="formAlert.repeatAlert">
                <label for="repeatAlert" class="mb-0">{{"MY_ALERTS.REPEAT" | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Frequency Row (animated expand when repeat is checked) -->
      <div class="col-12" *ngIf="formAlert.repeatAlert" @expandIn>
        <div class="row align-items-start frequency-row">
          <div class="col-auto">
            <div class="form-group">
              <label for="alertFrequency">{{"MY_ALERTS.FREQUENCY" | translate}}</label>
              <span class="error" *ngIf="alertForm.submitted">
                <span *ngIf="alertFrequency?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
              </span>
              <ng-select [items]="manualAlertFrequencyOptions"
                         rmsNgSelectEditFocused
                         bindLabel="name"
                         bindValue="value"
                         name="alertFrequency"
                         id="alertFrequency"
                         class="frequency-dropdown"
                         required
                         #alertFrequency="ngModel"
                         [(ngModel)]="formAlert.alertFrequency">
              </ng-select>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-group mb-0">
              <div class="radio-group-inline">
                <label class="radio-inline">
                  <input type="radio" name="indefiniteToggle" [value]="true"
                         [(ngModel)]="formAlert.indefiniteInstance">
                  <span>{{"MY_ALERTS.INDEFINITE" | translate}}</span>
                </label>
                <label class="radio-inline">
                  <input type="radio" name="indefiniteToggle" [value]="false"
                         [(ngModel)]="formAlert.indefiniteInstance">
                  <span>{{"MY_ALERTS.ENDS_AFTER_OCCURRENCES" | translate}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-auto" *ngIf="!formAlert.indefiniteInstance">
            <div class="form-group">
              <label for="instanceCount">{{"MY_ALERTS.OCCURRENCES" | translate}}</label>
              <span class="error" *ngIf="alertForm.submitted">
                <span *ngIf="alertInstance?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
              </span>
              <input name="instanceCount" id="instanceCount" #alertInstance="ngModel"
                     class="form-control occurrence-input" type="number"
                     [(ngModel)]="formAlert.instanceCount" required min="2"
                     pattern="^[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*$">
            </div>
          </div>
        </div>
      </div>

      <!-- Assigned To -->
      <div class="col-12">
        <div class="form-group">
          <label for="assignedTo">{{"MY_ALERTS.ASSIGNED_TO" | translate}}</label>
          <span class="error" *ngIf="alertForm.submitted">
            <span *ngIf="assignedTo?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
          </span>
          <ng-select [items]="memberList"
                     bindLabel="name"
                     [typeahead]="usersTypeahead"
                     [hideSelected]="true"
                     [multiple]="true"
                     name="assignedTo"
                     id="assignedTo"
                     required
                     #assignedTo="ngModel"
                     [(ngModel)]="formAlert.assignedTo">
          </ng-select>
        </div>
      </div>

      <!-- Add Primary/Secondary Checkboxes -->
      <div class="col-12">
        <div class="form-group">
          <div class="alert-primary-secondary-checkboxes">
            <div class="checkbox-inline d-flex align-items-center">
              <input type="checkbox" class="add-primary-checkbox"
                     id="add-primary-checkbox" name="addPrimary"
                     [(ngModel)]="formAlert.addPrimary"
                     [disabled]="companyMembers?.primaryUserId == null">
              <label for="add-primary-checkbox" class="mb-0">
                {{"MY_ALERTS.ADD_PRIMARY" | translate}}: <span class="person-name">({{companyMembers?.primaryUserFullname || "NONE"}})</span>
              </label>
            </div>
            <div class="checkbox-inline d-flex align-items-center">
              <input type="checkbox" class="add-secondary-checkbox"
                     id="add-secondary-checkbox" name="addSecondary"
                     [(ngModel)]="formAlert.addSecondary"
                     [disabled]="companyMembers?.secondaryUserId == null">
              <label for="add-secondary-checkbox" class="mb-0">
                {{"MY_ALERTS.ADD_SECONDARY" | translate}}: <span class="person-name">({{companyMembers?.secondaryUserFullname || "NONE"}})</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="col-12">
        <div class="form-group">
          <label for="description">{{"GENERICS.DESCRIPTION" | translate}}</label>
          <span class="error" *ngIf="alertForm.submitted">
            <span *ngIf="description?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
          </span>
          <textarea name="description" #description="ngModel" id="description"
                    class="form-control description-textarea"
                    [(ngModel)]="formAlert.description" rows="4" required></textarea>
        </div>
      </div>
    </div>

    <!-- Automatic Alert Edit (simplified form — frequency only) -->
    <div *ngIf="isCompanyMemberAlertEdit">
      <div class="col col-md-8">
        <div class="form-group">
          <label for="alertFrequencyAuto">{{"MY_ALERTS.FREQUENCY" | translate}}</label>
          <span class="error" *ngIf="alertForm.submitted">
            <span *ngIf="alertFrequencyAuto?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
          </span>
          <ng-select [items]="automaticAlertFrequencyOptions"
                     rmsNgSelectEditFocused
                     bindLabel="name"
                     bindValue="value"
                     name="alertFrequencyAuto"
                     id="alertFrequencyAuto"
                     #alertFrequencyAuto="ngModel"
                     [(ngModel)]="formAlert.alertFrequency">
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="activeModal.dismiss()">{{"GENERICS.CLOSE" | translate}}</button>
    <button type="submit" class="btn btn-primary">
      {{(isEditMode ? "GENERICS.SAVE" : "GENERICS.CREATE") | translate}}
    </button>
  </div>
</form>
